<template>
  <teleport to="#glasses-search-bar">
    <input
        type="text"
        class="form-control"
        :placeholder="translate('Item number')"
        v-model="filterText"
    />
  </teleport>

    <!-- Multicheckboxen -->
    <teleport to="#glasses-filter-types">
    <!-- Types  -->
    <multi-checkbox ref="types" @update:value="onMultiCheckboxChange" :filter="getFilter('types')" :_t="translate" v-bind:showtitle="showlabels"/>
    </teleport>
  <teleport to="#glasses-filter-styles">
    <!-- Styles  -->
    <multi-checkbox ref="styles" @update:value="onMultiCheckboxChange" :filter="getFilter('styles')" :_t="translate" v-bind:showtitle="showlabels"/>
  </teleport>
  <!-- Colorbox  -->
  <teleport to="#glasses-filter-colorbox">
    <multi-checkbox ref="colorgroups"  @update:value="onMultiCheckboxChange" :filter="getFilter('colorgroups')" :_t="translate"
                    v-bind:showlabel="false"/>
  </teleport>
  <!-- Brands  -->
  <teleport to="#glasses-filter-brands">
    <multi-checkbox v-if="!config.brands" ref="brands" @update:value="onMultiCheckboxChange" :filter="getFilter('brands')" :_t="translate"
                    v-bind:showtitle="false"/>
  </teleport>
  <!-- Scheibenformen  -->
  <teleport to="#glasses-filter-lensshapes">
    <!-- @todo Lensshapes soll Icons enthalten -->
    <multi-checkbox ref="lensshapes" @update:value="onMultiCheckboxChange" :filter="getFilter('lensshapes')" :_t="translate"
                    v-bind:showtitle="showlabels"/>
  </teleport>
  <!-- Material  -->
  <teleport to="#glasses-filter-material">
    <multi-checkbox ref="materials"  @update:value="onMultiCheckboxChange" :filter="getFilter('materials')" :_t="translate"
                    v-bind:showtitle="showlabels"/>
  </teleport>
  <!-- Merkmale  -->
  <teleport to="#glasses-filter-rahmenart">
    <!-- Rahmenarten -->
    <multi-checkbox ref="rahmenarten" @update:value="onMultiCheckboxChange" :filter="getFilter('rahmenarten')" :_t="translate"
                    v-bind:showtitle="showlabels"/>
  </teleport>
  <teleport to="#glasses-filter-charakteristics">

    <!-- Federscharnier -->
    <multi-checkbox ref="federscharnier" @update:value="onMultiCheckboxChange" :filter="getFilter('federscharnier')" :_t="translate"
                    v-bind:showtitle="false" v-bind:isSingle="true"/>
    <!-- verglasbar -->
    <multi-checkbox ref="verglasbar" @update:value="onMultiCheckboxChange" :filter="getFilter('verglasbar')" :_t="translate"
                    v-bind:showtitle="false" v-bind:isSingle="true"/>
    <!-- Verspiegelung -->
    <multi-checkbox ref="verspiegelung" @update:value="onMultiCheckboxChange" :filter="getFilter('verspiegelung')" :_t="translate"
                    v-bind:showtitle="false" v-bind:isSingle="true"/>
    <!-- Farbverlauf -->
    <multi-checkbox ref="farbverlauf" @update:value="onMultiCheckboxChange" :filter="getFilter('farbverlauf')" :_t="translate"
                    v-bind:showtitle="false" v-bind:isSingle="true"/>

  </teleport>
  <teleport to="#glasses-filter-glasfarbe">
    <multi-checkbox ref="glasfarbengroups"  @update:value="onMultiCheckboxChange" :prefix="'glass'" :filter="getFilter('glasfarbengroups')" :_t="translate"
                    v-bind:outerclass="'w-64 border-2 border-gray-400 p-8 rounded-lg bg-gray-100 cb-last-item'"  v-bind:showtitle="false" v-bind:showlabel="false"/>
  </teleport>
  <!-- Dimensions  -->

  <teleport to="#glasses-filter-dimensions">

        <range-slider ref="scheibenlaenge" @update:value="onMultiCheckboxChange" :filter="getFilter('scheibenlaenge')" :format="{postfix: 'mm'}"  :_t="translate"/>
        <range-slider ref="scheibenhoehe" @update:value="onMultiCheckboxChange" :filter="getFilter('scheibenhoehe')" :format="{postfix: 'mm'}"  :_t="translate"/>
        <range-slider ref="brueckenweite" @update:value="onMultiCheckboxChange" :filter="getFilter('brueckenweite')" :format="{postfix: 'mm'}"  :_t="translate"/>
        <range-slider ref="buegellaenge" @update:value="onMultiCheckboxChange" :filter="getFilter('buegellaenge')" :format="{postfix: 'mm'}" :_t="translate"/>
        <range-slider ref="weight" @update:value="onMultiCheckboxChange" :filter="getFilter('weight')" :format="{postfix: 'gr'}" :_t="translate"/>
  </teleport>
  <teleport to="#glasses-filter-counters">
    <p class="glass-count">
      {{ shownGlasses }} {{ translate('Models') }}
    </p>
    <p class="glass-total">
      {{ totalGlasses }} {{ translate('Models') }}
    </p>
  </teleport>
  <teleport to="#glasses-filter-counter-footer">
      {{ totalGlasses }} {{ translate('Models') }}
  </teleport>

  <teleport to="#glasses-filter-reminders">
    <div v-for="(filterItem, i) in filters" :filterItem="filter" :key="i">
      <div v-if="filterItem.queries.length" class="reminder">
        <a @click.prevent="removeFilter(filterItem)" href="#">
          <span class="reminder-icon"></span>
          <span class="reminder-value">{{ translate(filterItem.label) }}</span>
        </a>
      </div>
    </div>
    <div v-if="hasFilters" class="reminder">
      <a @click.prevent="removeAllFilters()" href="#">
        <span class="reminder-icon"></span>
        <span class="reminder-value">{{ translate('Clear all filters') }}</span>
      </a>
    </div>
  </teleport>
  <teleport to=".eon-glasses-filter-remove-all-btn">
      <button :disabled="!hasFilters" @click.prevent="removeAllFilters()" href="#">
        {{ translate('Clear all filters') }}
      </button>
  </teleport>

  <teleport to="#glasses-list">
    <!-- Die Artikel-Liste -->
    <div class="glasses-list-inner" :class="{empty: shownGlasses === 0 }">
      <GlassItem v-for="(glass, i) in filteredGlasses"
                 :Glassitem="glass"
                 :baseurl="'/' + language + '/' +  translate('model').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()  + '/'"
                 :key="i"
                 @item-clicked="onItemClicked"
                 :translate="translate"
                 :config="config"
                 :sort-colors="sortColors"
      />
    </div>
    <div id="load_more">
      <button @click="showMore()" type="button" name="show_more_button" class="btn" id="show_more_button">
        {{ translate('show more') }}
      </button>
    </div>
  </teleport>
  <teleport to="#glasses-sorting">
  <check-box v-for="(sorter, key) in sorting"
    :ref="sorter.id"
    :key="key"
    @update:checked="setSorting(key, $event)"
    :checked="checkSorting(key)"
    :fieldId="sorter.id"
    :label="translate(sorter.label)"
    className="sorting"
  />
  </teleport>
</template>

<script>
import {ref} from 'vue'
import {eonUserState} from '@/composable/eonUserState'
import {hideFilters, hideFilter, waitUntil} from '@/composable/eonUtils'
// hier wird das Json-Objekt geladen
import {fetchJsonObject} from '@/composable/fetchJsonObject'
// Komponente zur Darstellung eines Einzelnen Artikels

import Checkbox from "@/components/check-box";

import GlassItem from '@/components/glassitem'
// Multi-Checkbox-Komponente
import MultiCheckbox from '@/components/multi-checkbox'
// Range-Slider-Komponente
import RangeSlider from '@/components/range-slider'
import debounce from 'lodash/debounce'
export default {
  inheritAttrs: false,
  name: 'App',
  props: {
    config: Object,
  },
  data() {
    return {
    }
  },
  setup (props) {
    // config holen
    const preferredView = ref(props.config.preferredView)

    // Funktionen aus composable eonUserState bereitstellen
    const {initEonUserstate, getEonUserstate, setEonUserstate} = eonUserState()
    // initiale Funktion ausführen
    initEonUserstate()
    // fetchJsonObject.js holt Artikelliste, Filter-Objekt, sorting-Objekt, translation-Objekt
    const {GlassesList, filters, translation, sorting, brands} = fetchJsonObject(props.config)

    const totalGlasses = ref(0)
    const shownGlasses = ref(0)
    const rahmenarten = ref()
    const GlassItems = ref([]);
    const filter = ref(false);
    const sortColors = ref(false);
    const hasFilters = ref(false);

    const initFilterText = getEonUserstate('eonArticleNr') ? getEonUserstate('eonArticleNr') : props.config.initFilterText != undefined ? props.config.initFilterText : "";
    // filterText zeigt auf Texteingabe der Artikelnr-Suche
    const filterText = ref(initFilterText.toString())
    // Sortierung aus dem Userstate falls vorhanden
    const eonSortingFromState = getEonUserstate('eonSorting') ? JSON.parse(getEonUserstate('eonSorting')) : {};
    // aktuelle Sortierung aus Userstate oder 'aktuell'
    const curSorting = ('curSorting' in eonSortingFromState) ? ref(eonSortingFromState.curSorting) : ref('aktuell');
    // aktuelles Sortierfeld aus Userstate oder 'aktuell'
    const sortField = ('sortField' in eonSortingFromState) ? ref(eonSortingFromState.sortField) : ref("aktuell");
    // aktuelle Sortierrichtung aus USerstate oder 'desc'
    const sortDir = ('sortDir' in eonSortingFromState) ? ref(eonSortingFromState.sortDir) : ref("desc");
    // Anzahl initial anzuzeigender Seiten aus Userstate oder Config
    const itemsperpage = getEonUserstate('eonItemsperpage') ?  getEonUserstate('eonItemsperpage') : props.config.itemsperpage

    /** @todo aktuelle Sprache dynamisch setzen */
    const language = ref(props.config.language ? props.config.language : 'de')

    const checkFilters = function() {
      return Object.values(filters).length
    }
    // unnötige Filter löschen
    waitUntil(checkFilters, function () {
      Object.values(filters).forEach((filter) => {
        if(typeof filter === 'object' && Object.values(filter).length) {
          Object.values(filter).forEach((filter) => {
            if(!filter.options || filter.options.length > 1 ) return;
            hideFilter(filter.namespace)
          })
        }
      })
    })

    return {
      GlassesList,
      filterText,
      filters,
      translation,
      brands,
      sorting,
      language,
      totalGlasses,
      shownGlasses,
      itemsperpage,
      rahmenarten,
      GlassItems,
      filter,
      hasFilters,
      sortField,
      sortDir,
      curSorting,
      sortColors,
      getEonUserstate,
      setEonUserstate,
      preferredView

    }
  },
  created: function () {

  },
  mounted() {
    hideFilters(this.config)
    this.doSorting()
  },
  updated: debounce(function () {

    this.$nextTick(function () {
        let LastItemVisited = document.getElementById(this.getEonUserstate('eonLastItemVisited'))
        // Wenn das Element bereits geladen ist
        if (LastItemVisited) {
          // scrolle smooth
          LastItemVisited.scrollIntoView({behavior: "smooth", block: "center"});
        }
    })
  }, 1500),
  computed: {
    showlabels: function() {
      return !this.config.hideTitles
    },
    filteredGlasses: function () {
      // Sortierung
      this.doSorting()
      // Falls nur bestimmte Marken gezeigt werden sollen
      this.filterBrandsFromConfig()
      // Filter anwenden
      let glasses = this.filterGlassesByModel(this.filterGlassesByCheckboxes(this.filterGlassesMissingImage(this.GlassesList)))

      // so viele Items holen, wie für die Seite definiert ist
      const glassesFiltered = glasses.slice(0, this.itemsperpage)
      // Anzahl aller Items notieren
      this.setTotal(glasses.length)
      // Anzahl der auf der Seite angezeigten Items notieren
      this.setShown(glassesFiltered.length)
      // Notieren ob filter gesetzt sind
      this.setHasFilters(Object.values(this.filters).filter(
          f => {
            return Array.isArray(f.queries) && f.queries.length > 0
          }
      ))
      // Rückgabe der gefilterten Items
      return glassesFiltered
    },
    // Übersetzung
    translated: function(key) {
      return this.translate(key)
    }
  },
  methods: {

    /**
     * eine weiter Seite anzeigen
     */
    showMore: function () {

      this.itemsperpage = this.itemsperpage + this.config.itemsperpage
      this.updateState('itemsperpage')
      // eine Mutation muss stattfinden, damit es ein update gibt
      // zweimal rumdrehen ist zwar unsinnig aber erfüllt den Zweck
      this.GlassesList.reverse().reverse()
    },
    /**
     * Sortierung definieren
     * @param field
     * @param dir
     * @param event
     */
    setSorting(field, event) {
      const self = this
      // das sorting Objekt wurde bereits aus dem JSON ausgelesen?
      if(this.sorting !== undefined ) {
        // Checkbox wurde deaktiviert
        if(event === false) {
          // deaktivieren ist bei der Sortierung nicht erlaubt....
          const component = this.$refs[this.sorting[field].id][0]
          // ...die geuncheckte Checkbox wieder aktivieren
          for(const art of  component.$el.getElementsByTagName('input') ) {
            art.checked = true
          }
          return
        }  else {
          // Checkbox wurde aktiviert. Alle Sortierungen durchlaufen...
          for (const [namespace, sorter] of Object.entries(this.sorting)) {
            // aktivierte Checkbox wurde gefunden...
            if (namespace === field) {
              // die aktuelle Sortierung notieren
              this.curSorting = namespace
              self.sortField = sorter['key']
              self.sortDir = sorter['value']
            }
          }
        }
        // Sortierung ausführen
        this.doSorting()
        // Userstate Objekt (Element eonSorting) aktualisieren
        this.updateState('sorting')
      }
    },
    /**
     * Items Sortieren
     * Sortierung nach dem in sortField definierten Objektattribut und der in sortDir definierten Richtung
     */
    doSorting() {
      const self = this
      this.GlassesList.sort(function(a , b) {
        if( a[self.sortField] > b[self.sortField] ){
          return self.sortDir === 'desc' ? -1 : 1;
        } else {
          if( a[self.sortField] === b[self.sortField] ){
            return  0;
          } else {
            if( a[self.sortField] < b[self.sortField] ){
              return  self.sortDir === 'desc' ? 1 : -1;
            }
          }
        }
      })
    },
    /**
     * Checkt, ob ein Feld dem aktuellen Sortierfeld entspricht
     * @param field
     * @returns {boolean}
     */
    checkSorting(field) {
      return this.curSorting === field
    },
    /*
     * Beim Entfernen der Filter die Bedienelemente zurücksetzen
     */
    removeFilter: function (filter) {
      let component = this.$refs[filter.namespace]
      // weiss nicht warum, aber das reset muss manuell gemacht werden
      if (filter.type === 'range') {
        component.reset()
      }
      for(const art of  component.$el.getElementsByTagName('input') ) {
        art.checked = false
      }
      filter.queries = []
      this.updateState('filters')
    },
    /**
     * Alle Filter entfernen
     */
    removeAllFilters: function() {
      for (const filter of Object.values(this.filters)) {
        this.removeFilter(filter)
      }
    },
    /**
     * Übersetze einen String. str ist ein Key im Translation-Objekt
     * @param str - Der zu übersetzende String|Key im Translation-Objekt
     * @returns {string}
     */
    translate: function(str) {
      const language =  this.config.language
      if((language in this.translation) && (str in this.translation[language])) {
        return this.translation[language][str]
      }
      return str;
    },
    /**
     * Set the total number of filtered glasses
     * @param {Number} num
     */
    setTotal(num) {
      this.totalGlasses = num
    },
    /**
     * Are Filters present?
     * @param hasFilters
     */
    setHasFilters(hasFilters) {
      this.hasFilters = hasFilters.length > 0
    },
    /**
     * updateState
     * Update eines Elements des UserState-Objekts
     * Die Kategorien filters, sorting, article, itemsperpage entsprechen den folgenden Elementen
     * 'eonFilters' - die gesetzten Filter
     * 'eonSorting' - die gesetzte Sortierung
     * 'eonArticleNr' - im Suchfeld eingegebene Modelnummer
     * 'eonItemsperpage' - Zuletzt auf der Seite angezeigte Anzahl der Items
     * @param category  - filters|sorting|article|itemsperpage
     */

    updateState(category) {
      // Element eonFilters aktualiseren
      if(category == 'filters') {
        const filters = {}
        // alle Filter suchen, die gesetzt sind (also queries haben)
        for (const [namespace, filter] of Object.entries(this.filters)) {
          if(filter.queries.length) {
            filters[namespace] = filter.queries
          }
        }
        // gesetzte Filter im Userstate aktualisieren
        this.setEonUserstate('eonFilters',JSON.stringify(filters))
      }
      // Element eonSorting aktualiseren
      if(category == 'sorting') {
        this.setEonUserstate('eonSorting',JSON.stringify({ curSorting: this.curSorting, sortDir: this.sortDir, sortField: this.sortField}))
      }
      // Element eonArticleNr aktualiseren
      if(category == 'article') {
        this.setEonUserstate('eonArticleNr', this.filterText.toLowerCase())
      }
      // Element eonItemsperpage aktualiseren
      if(category == 'itemsperpage') {
        this.setEonUserstate('eonItemsperpage', this.itemsperpage)
      }
    },
    /**
     * Set the number of shown glasses
     * @param {Number} num
     */
    setShown(num) {
      this.shownGlasses = num
    },
    /**
     * Getter für einzelnen Filter
     * @param key - Der Key/Namespace des Filters
     * @returns {{}} - Filter
     */
    getFilter: function(key) {
      if(typeof this.filters[key] === 'object') {
        this.filters[key].namespace = key
        return this.filters[key]
      }
      return {}
    },
    /**
     * Führt den Artikelnummern-Suche-Filter aus
     *
     * @param {Array} glasses Liste zu filternder Artikel
     * @returns {Array} Artikel-Liste
     */
    filterGlassesByModel: function (glasses) {
      this.updateState('article')
      return glasses.filter(glass =>
          glass.article_nr.toLowerCase().includes(this.filterText.toLowerCase())
      )
    },
    /**
     * Nur Brillen zeigen, deren Bilder präsent sind
     * @param glasses
     * @returns {Array}
     */
    filterGlassesMissingImage: function (glasses) {

      return glasses.filter(glass =>
          glass.colors.some(v => v.imageMissing === false)
      )
    },
    filterBrandsFromConfig: function () {
      if(this.GlassesList.length && 'brands' in this.config && 'brands' in this.filters ) {
        try {
          const useBrands = this.config.brands.match(/[^,\s]+/g)
          if(Array.isArray(useBrands)) {
            delete this.filters.brands
            this.GlassesList = this.GlassesList.filter((glass) => useBrands.includes(glass.brand))
          }

        } catch(err) {
          return false
        }
      }

    },
    /**
     * Führt alle Checkbox-Listen-Filter aus
     *
     * @param {Array} glasses Liste zu filternder Artikel
     * @returns {Array} Artikel-Liste
     * @todo format (mm oder gr) für ranges
     * @todo Gewicht ist ein Float
     */
    filterGlassesByCheckboxes: function (glasses) {
      if (!Array.isArray(glasses)) return [];
      // Alle Filter durchlaufen

      for (const [namespace, filter] of Object.entries(this.filters)) {

        // filter.queries enthält eine Liste von Eigenschaften des Artikels,
        // nach denen gefiltert werden soll
        // Wenn die Liste einen Eintrag hat, ist eine option gecheckt - dann ausführen
        if (filter.queries.length >= 1) {
          // Wenn der Filter ein Range ist...
          if(filter.type === 'range') {
            if(filter.queries[1]) {
              // ... wird nach Items gefiltert, deren durch namespace definiertes Attribut größer als das Minimum
              // (im ersten Query definiert) und kleiner als das Maximum (im zweiten Query definiert)
              glasses = glasses.filter(glass =>
                  {
                    let queryMin = parseInt(filter.queries[0])
                    let queryMax = parseInt(filter.queries[1])
                    return (parseInt(glass[namespace]) >= queryMin) && (parseInt(glass[namespace]) <= queryMax)
                  }
              )
            }
          } else {
            // Ein Filter bei dem mehrere Werte in einem einzigen Attribut eines Items enthalten sein können (Farben),
            // wird durch die Eigenschaft queryChildList gekennzeichnet
              if (filter.queryChildList) {
                // Suche nach Items, in deren durch namespace definierten Attribut eines oder mehrere der Werte aus den
                // filter.queries enthalten ist
                glasses = glasses.filter(glass =>
                    {
                      return filter.queries.some( v => glass[namespace].includes(v))
                    }
                )
              } else {
                // Suche nach Items, deren durch den Filter in filter.key definierten Attribut einem der Werte aus den
                // filter.queries entsprechen
                glasses = glasses.filter(glass =>
                    {
                      return filter.queries.includes(glass[filter.key])
                    }
                )
              }
            // pass
          }
        }
      }
      return glasses
    },
    /**
     * Wird von einer MultiCheckbox beim Check einer Option ausgeführt.
     * Die Funktion 'check' der MultiCheckbox übergibt die Wert aller gesetzen Optionen
     * und den Namespace des zuständigen Filters
     * @param  {Array} queries - Liste von Werten einer Artikeleigenschaft
     * @param namespace - Namespace des Filters
     */
    onMultiCheckboxChange: function (queries, namespace) {

      // Werte der Checkbox-Liste werden in den Queries des Filters gespeichert
      this.filters[namespace].queries = Array.isArray(queries) ? queries : queries ? [queries] : queries;
      this.sortColors = this.filters.colorgroups.queries
      this.updateState('filters')

    },
    /**
     * Wenn ein Artikel angeklickt wird um die Detailseite zu besuchen, wird dies im Userstate gepeichert,
     * um nach der Rückkehr via Backbutton dorthin scrollen zu können
     * @param event
     * @param elementId
     */
    onItemClicked(event, elementId) {
      this.setEonUserstate('eonLastItemVisited', elementId)
    },

  },
  components: {
    GlassItem,
    MultiCheckbox,
    RangeSlider,
    "check-box": Checkbox,
  }
}
</script>
<style scoped>
@import 'app.css';
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@vueform/slider/themes/default.css"></style>
<style src="@vueform/slider/themes/tailwind.css"></style>

